function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.5 6A2.5 2.5 0 002 8.5v15A2.5 2.5 0 004.5 26h23a2.5 2.5 0 002.5-2.5v-15A2.5 2.5 0 0027.5 6h-23zM4 9.302V23.5a.5.5 0 00.5.5h23a.5.5 0 00.5-.5V9.302l-8.8 7.332a5 5 0 01-6.4 0L4 9.302zM26.438 8H5.562l8.517 7.098a3 3 0 003.842 0L26.438 8z",
  fill: "currentColor"
})));